"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getNoDataTips = exports.getNoDataTips = function getNoDataTips(className) {
    $(className).fadeIn(1000, function () {
        setTimeout(function () {
            $(className).fadeOut();
        }, 1000);
    });
};


//////////////////
// WEBPACK FOOTER
// ./js/util/tips.js
// module id = 27
// module chunks = 0